
import React from "react";
import {MDBContainer} from "mdb-react-ui-kit";
import "../css/servicesfont.css";

export default function ConsultancyInfo() {
    return (
      <MDBContainer fluid className="p-0">
          <div className="container py-5">
            <div className="row">
                    <div className="col-12">
                        <div className="section-title mb-4 pb-2">
                            <h1 className="title mb-4 display-heading AcerhealthTextPurple text-center fomtsizetest" style={{fontFamily:'Lora, serif'}}>Credentialing Services</h1>
                            <p className="para-desc mx-auto mb-0" style={{fontSize:'20px',fontFamily: 'Alegreya Sans',fontWeight:'500' ,textAlign:'justify'}}>
                           At AcerHealth, our credentialing team is committed to helping providers join insurance networks faster and with less hassle. Backed by years of 
                           experience and industry expertise, we’ve delivered successful <b>credentialing services </b>to over <b>300 healthcare providers </b>across the U.S. Our
                            specialists ensure accurate, efficient provider enrollment that aligns seamlessly with your existing <b>medical billing services </b>and 
                             <a
                            href="https://acerhealth.com/services/revenue-cycle-management"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
             revenue cycle management 
                        </a> processes.</p>
                         <p className="para-desc mx-auto mb-0" style={{fontSize:'20px',fontFamily: 'Alegreya Sans',fontWeight:'500' ,textAlign:'justify'}}>
                           AcerHealth offers integrated  
                             <a
                            href="https://acerhealth.com/services/medical-billing-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
           medical billing outsourcing 
                        </a>solutions that include credentialing support, compliance verification, and ongoing payer communication. As a trusted name in 
                        <a
                            href="https://acerhealth.com/services/medical-consultancy-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
          medical consultancy services,
                        </a>
                     
                         we simplify complex enrollment procedures—reducing delays, minimizing denials, and supporting the financial health of your practice.</p>
                        </div>
                    </div>
                </div>
          </div>
       </MDBContainer>
    );
}
